/** The Bookings page piece, standard look over its behavior half. */
import type { ReactNode } from 'react';

import type { PieceInput } from '../../contract/runtime';
import { useWebDashboard } from '../../hooks/useWebAccount';
import type { BookingsListEvents } from './contract';
import { BookingsListView } from './BookingsListView';
import { useBookingsList } from './useBookingsList';

export { BookingsListView, useBookingsList };

/**
 * `nextOnTop`: the page shows the next session above the list (web-studio-sites D12), so Upcoming leaves it out, and
 * with none after it Upcoming doesn't show (Gabriel 2026-10-27).
 */
export function BookingsList({ top, nextOnTop = false, ...props }: PieceInput<BookingsListEvents> & { readonly top?: ReactNode; readonly nextOnTop?: boolean }) {
  const runtime = useBookingsList(props);
  const nextId = useWebDashboard().data?.nextBooking?.id;
  if (!nextOnTop || !nextId) return <BookingsListView {...runtime} top={top} />;
  const upcoming = runtime.state.upcoming.filter((row) => row.id !== nextId);
  return <BookingsListView {...runtime} state={{ ...runtime.state, upcoming }} top={top} hideEmptyUpcoming />;
}
